import { FC, useState } from 'react'
import { StakingContentContainer } from './StakingContentContainer'
import { Link } from 'react-router-dom'
import { CheckMarkIcon } from '../../assets/Icons'
import { SolidButton } from '../../common/components'

const CheckBox: FC<{
  checked: boolean
  setChecked(v: boolean): void
  title?: string | ReactElement
}> = (props) => {
  return (
    <div
      className="flex items-center gap-5  cursor-pointer"
      onClick={() => props.setChecked(!props.checked)}
    >
      <div
        style={{
          background: props.checked ? '#FE902A' : undefined,
          border: props.checked ? '0px solid' : undefined,
        }}
        className="size-6 min-w-6 rounded-md border border-[#F4F3FF]/10 bg-[#F4F3FF]/10 flex items-center justify-center"
      >
        {props.checked && <CheckMarkIcon />}
      </div>
      {props.title && (
        <div className="text-white font-medium">{props.title}</div>
      )}
    </div>
  )
}

const lsAgreementPropName = 'staking_agreement_accepted'
const isAgreed = localStorage.getItem(lsAgreementPropName)

export const StakingModal: FC<{
  close: () => void
}> = (props) => {
  const [state, setState] = useState<'none' | 'agreed'>(
    isAgreed ? 'agreed' : 'none'
  )

  const [isAgreementChecked, setIsAgreementChecked] = useState(false)

  const handleContinueClick = () => {
    localStorage.setItem(lsAgreementPropName, 'true')
    setState('agreed')
  }

  return (
    <div
      style={{ height: '100vh' }}
      className="z-20 fixed w-full inset-0 flex items-center justify-center bg-black bg-opacity-30"
      onClick={() => props.close()}
    >
      <div
        style={{
          background: '#17191B',
          //   width: props.width,
        }}
        className="w-fit max-md:w-[90%] 0p-6 rounded-xl"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {state === 'none' && (
          <div className="w-[600px] max-md:w-full">
            <div className="p-6 pb-0 flex flex-col gap-[10px]">
              <div className="text-white text-[15px]">
                By entering this site you confirm that you have read our{' '}
                <Link to="/terms" className="underline">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy" className="underline">
                  Privacy Policy,
                </Link>{' '}
                that you are 18 years of age or older, and that you are NOT
                located in, domiciled in, tax resident in, a citizen or resident
                of a legal person with domicile, presence, or tax liability in
                any of: Burma (Myanmar), Burundi, Canada Central African
                Republic, Congo, Cote d'Ivoire, Crimea, Cuba, Iran, Iraq,
                Lebanon, Liberia, Libya, Mali, Nicaragua, North Korea, Somalia,
                South Sudan, Sudan, Syria, Russia, United States of America,
                Venezuela, Yemen, and Zimbabwe. <br />
                <br />
                The use of decentralized finance products is an advanced
                practice and may result in the absolute and irrecoverable loss
                of user funds, at the user's expense. Ensure that you understand
                key concepts such as slippage, impermanent loss, staking,
                decentralized exchanges, and swaps.
              </div>

              <div className="h-10 flex items-center gap-2 cursor-pointer">
                <CheckBox
                  checked={isAgreementChecked}
                  setChecked={setIsAgreementChecked}
                />
                <div className="text-white text-[15px]">
                  I have read the terms above and agree to them.
                </div>
              </div>
            </div>
            <div className="p-6 flex items-center justify-end gap-[10px]">
              {/* <SettingsButton
                              style={{
                                height: 36,
                                fontSize: 14,
                                fontWeight: 600,
                              }}
                              unselected
                              onClick={() => navigate('/')}
                            >
                              Back to home
                            </SettingsButton> */}
              <SolidButton
                style={{
                  color: 'white',
                }}
                className="!py-2 !px-4 text-base bg-gray-500 bg-opacity-10 hover:bg-gray-500 hover:bg-opacity-15 active:bg-opacity-20"
                onClick={() => props.close()}
              >
                Back
              </SolidButton>
              <SolidButton
                className="!py-2 !px-4 text-base"
                onClick={handleContinueClick}
                disabled={!isAgreementChecked}
              >
                Continue
              </SolidButton>
            </div>
          </div>
        )}

        {state === 'agreed' && <StakingContentContainer />}
      </div>
    </div>
  )
}
